import React from 'react';
import { Grid } from '@mui/material';

import { ContainerColumnLeft } from '@occc-app/design-system';

import { CardLayout } from '@occc/ui-design-system';
import { Segment } from './Segment';

import { Segment as SegmentAttribute } from '../../types';

interface ISegmentsProps {
  segments: SegmentAttribute[];
}

export const Segments: React.FC<ISegmentsProps> = ({ segments }) => {
  return (
    <ContainerColumnLeft>
      <CardLayout title='Custom Segments'>
        <Grid container={true} spacing={2}>
          {segments.map((item, index) => (
            <Grid key={index} item={true} xs={12} sm={6} lg={3}>
              <Segment attribute={item} />
            </Grid>
          ))}
        </Grid>
      </CardLayout>
    </ContainerColumnLeft>
  );
};
